import equipmentStandardImage from 'assets/images/equipment_standard.jpg';
import equipmentPremiumImage from 'assets/images/equipment_premium.jpg';
import equipmentSuperiorImage from 'assets/images/equipment_superior.jpg';
import type { IScreenLinkData } from 'components/common/ScreenLink/ScreenLink';

const moreInfoEquipmentType: IScreenLinkData = {
  type: 'screen_link',
  // label: '',
  title: 'project_wizard.equipment_type',
  content: [
    {
      key: 1,
      image: {
        src: equipmentStandardImage,
      },
      description: [
        {
          type: 'title',
          text: 'project_wizard.equipment_type_content.standard_title',
        },
        {
          type: 'paragraph',
          text: 'project_wizard.equipment_type_content.standard_description',
        },
      ],
    },
    {
      key: 2,
      image: {
        src: equipmentPremiumImage,
      },
      description: [
        {
          type: 'title',
          text: 'project_wizard.equipment_type_content.premium_title',
        },
        {
          type: 'paragraph',
          text: 'project_wizard.equipment_type_content.premium_description',
        },
      ],
    },
    {
      key: 3,
      image: {
        src: equipmentSuperiorImage,
      },
      description: [
        {
          type: 'title',
          text: 'project_wizard.equipment_type_content.superior_title',
        },
        {
          type: 'paragraph',
          text: 'project_wizard.equipment_type_content.superior_description',
        },
      ],
    },
  ],
};

export default moreInfoEquipmentType;
